import React, { useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import Login from './login';
import Register from './register';
import ForgetPassword from './forgetPassword';
import Footer from '../../common_comp/Footer/Footer';
import VerifyOtp from './verifyOtp';
import ResetPassword from './resetPassword';
import { useAuth } from '../../hooks/useAuth';

const AuthRoute = () => {
  const navigate=useNavigate()
  const { isAuthenticated } = useAuth();
  useEffect(()=>{
    if(isAuthenticated){
      navigate('/author/articles')
    }
  },[isAuthenticated])
  return (
   <>
    <div className="container-fluid">
      <div className="row" style={{ height: '100vh' }}>
        <div className="col-md-6 d-flex align-items-center justify-content-center text-center auth_left base_background_color">
            <h1 className='my-auto' >Journal of <br/> Applied Bioanalysis</h1>
        </div>
        <div className="col-md-6 d-flex align-items-center justify-content-center text-center">
          <Routes>
            <Route path="/login" element={<Login />} />
       
            <Route path="/register" element={<Register />} />
            <Route path="/verify-otp" element={<VerifyOtp />} />
            <Route path="/forget-password" element={<ForgetPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Routes>
        </div>
      </div>
  
    </div>

<div style={{marginTop:"-70px"}}> 
<Footer/>
</div>
    </>
  );
};

export default AuthRoute;
